<template>
  <b-row>
    <b-col>
      <divisoria-descricao
        :titulo="titulo"
        :descricao="descricao"
        :alterar-informacao="alterarInformacao"
      >
        <template #custom-button>
          <b-col
            v-if="alterarInformacao"
            cols="auto"
          >
            <b-btn
              v-b-tooltip.hover
              variant="none"
              title="Alterar"
              class="btn-outline-primary btn-none rounded-pill icone-acao mr-50"
              @click="alterarDados"
            ><feather-icon icon="EditIcon" /></b-btn>
            <info-checklist
              :item-id="getCodeValidation()"
              :item="item"
            />
          </b-col>

          <modal-justificativa
            id="'modalJustificativa'"
            :ref="'modalJustificativa'"
            :texto-apresentacao="'Informe o motivo da alteração'"
            @cancelar="cancelar()"
            @confirmar="confirmar($event)"
          />
        </template>
      </divisoria-descricao>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'DivisoriaDescricaoContrato',
  components: {
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    InfoChecklist: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/checklist-proposta/shared/components/InfoChecklist.vue'),
    ModalJustificativa: () => import('@/shared/components/modal-justificativa/ModalJustificativa.vue'),
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    mensagemAlerta: {
      type: Boolean,
      default: false,
    },
    titulo: {
      type: String,
      default: '',
    },
    descricao: {
      type: String,
      default: '',
    },
    alterarInformacao: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getCodeValidation() {
      return Date.now().toString(36) + Math.random().toString(36).substring(2)
    },
    alterarDados() {
      if (this.mensagemAlerta) {
        this.$confirmar('Tem certeza que deseja alterar os dados?', 'Se os dados dos sócios foram importados através do vínculo que será alterado, se refazer a busca de dados, o sistema irá remover os sócios e depois importá-los novamente!', 'question', 'danger')
          .then(result => {
            if (result.value) {
              this.$refs.modalJustificativa.show()
            }
          })
      } else {
        this.$refs.modalJustificativa.show()
      }
    },
    cancelar() {
      this.$refs.modalJustificativa.hide()
    },
    confirmar(mensagem) {
      const justSemEspaco = mensagem.replace(/\s+/g, '')
      if (!mensagem || justSemEspaco.length < 10) {
        this.$erro(!mensagem ? 'A justificativa para a alteração é obrigatória.' : 'A justificativa deve ter no mínimo 10 caracteres!')
      } else {
        this.$emit('alterar-dados', mensagem)
        this.$refs.modalJustificativa.hide()
      }
    },
  },
}
</script>
